// Extracted to break circular import between application.component.ts and app-resources-view.component.ts
export enum ResourcesTab {
  RECOVERY_ENVIRONMENT,
  BACKUP,
  FAILBACK,
  ISSUES,
}
